// タブ切り替え
const acClass = 'active';

document.addEventListener('click', (e) => {
  const tabEl = e.target.closest('[data-tgt]');
  if (!tabEl) return;

  const box = tabEl.closest('[data-tabs]');
  if (!box) return;

  const tabs = box.querySelectorAll('[data-tgt]');
  const cons = box.querySelectorAll('[data-cont]');
  const tgt  = tabEl.dataset.tgt;

  tabs.forEach(el => {
    el.classList.toggle(acClass, el === tabEl);
  });

  cons.forEach(sec => {
    sec.classList.toggle(acClass, sec.dataset.cont === tgt);
  });
});


//ドロップダウン
function ddown(targetSelector) {
  const acClass = 'is-open';
  const targets = document.querySelectorAll(targetSelector);
  if (!targets.length) return;

  targets.forEach((dt) => {
    const content = dt.nextElementSibling;
    if (!content) return;
    content.style.height = '0';
    content.style.overflow = 'hidden';

    dt.addEventListener('click', (e) => {
      if (e.target.closest('button')) {
        e.preventDefault();
      }

      if (content.offsetHeight === 0) {
        content.style.height = 'auto';
        const h = content.offsetHeight;

        dt.classList.add(acClass);

        content.animate(
          [{ height: '0px' }, { height: h + 'px' }],
          { duration: 300 }
        ).onfinish = () => {
          content.style.height = 'auto';
        };
      } else {
        const h = content.offsetHeight;

        dt.classList.remove(acClass);

        content.animate(
          [{ height: h + 'px' }, { height: '0px' }],
          { duration: 300 }
        ).onfinish = () => {
          content.style.height = '0';
        };
      }
    });
  });
}
ddown('.tmg__cont-qa dt');


/*ポジショニングマップ展開*/
function toggleMapSP() {
  const btn = document.querySelector('.tmg__cont-btn');
  const target = document.querySelector('.tmg__cont-map-sp');
  const body = document.body;
  const acClass = 'is-op';

  if (!btn || !target) return;

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    target.classList.add(acClass);
    body.classList.add(acClass);
  });

  target.addEventListener('click', (e) => {
    if (e.target.closest('img, svg')) return;

    target.classList.remove(acClass);
    body.classList.remove(acClass);
  });
}
toggleMapSP();